export const apiEndpoint = {
  pdfBaseUri: "https://pdf.meon.co.in",
  esignBaseUri: "https://esign.meon.co.in",
  developerToolBaseUri: window.location.host.includes("localhost")
    ? "http://127.0.0.1:8000"
    : "https://developer.meon.co.in",
};
